import { useParams } from "react-router";
import { EBPlayButton } from "./chants/audio/EBPlayButton";
import { EBChant } from "./chants/eb-chant/EBChant";
import { useDataDependency } from "./utils/RemoteDataProvider";

export const AllAnts = () => {
    const { mode } = useParams<{
        mode: string;
    }>();

    const loadableAnts = useDataDependency<
        { gabc: string; tone: string; id: string; simpleGabc: string }[]
    >({
        type: "all ants",
        mode,
    });

    if (loadableAnts.state === "loaded") {
        const textAnts = {};

        loadableAnts.value.forEach((item) => {
            textAnts[item.id] = {
                pointedText: item.gabc
                    .split("(::)")[0]
                    .replace(/\(\:\)/g, "|")
                    .replace(/\(\;\)/g, "|")
                    .replace(/\(\@\:\)/g, "|")
                    .replace(/\(\@\;\)/g, "|")
                    .replace(/\(,\)/g, "")
                    .replace(/\(.*?\)/g, "_")
                    .replace("$", "*")
                    .replace(/<sc>/g, "")
                    .replace(/<\/sc>/g, "")
                    .replace(/_ /g, " ")
                    .replace(/([a-z])-([a-z])/g, "$1$2")
                    .replace(/ +/g, " ")
                    .replace(/\| /g, "|")
                    .trim(),
                tone: item.tone.replace("trans", ""),
                done: false,
            };
        });

        console.log(textAnts);

        return (
            <div>
                <div>Total chants: {loadableAnts.value.length}</div>

                {loadableAnts.value
                    .sort((a, b) => {
                        if (mode === "8") {
                            if (
                                a.gabc.indexOf("(eh)") ||
                                a.gabc.indexOf("(gj)")
                            ) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }

                        return 1;
                    })
                    .map((item) => {
                        return (
                            <div key={item.gabc} style={{ paddingBottom: 32 }}>
                                <div>{item.gabc}</div>
                                <EBPlayButton
                                    gabc={item.gabc}
                                    tone={item.tone}
                                    title="Play"
                                    tweak={0}
                                />
                                <EBChant
                                    dropCap={true}
                                    gabc={item.gabc}
                                    tone={item.tone}
                                />
                                <div style={{ border: "1px solid black" }}>
                                    <div style={{ fontWeight: "bold" }}>
                                        {item.id}
                                    </div>
                                    <EBPlayButton
                                        gabc={item.simpleGabc}
                                        tone={item.tone}
                                        title="Play simple"
                                        tweak={0}
                                    />
                                    <EBChant
                                        dropCap={true}
                                        gabc={item.simpleGabc}
                                        tone={item.tone}
                                    />
                                </div>
                            </div>
                        );
                    })}
            </div>
        );
    } else {
        return <div>Loading</div>;
    }
};
